import React from 'react'
import styles from './styles.module.css'
import AddIcon from '../../../../icons/AddIcon'
import { $textPrimary } from '../../../../../styles/colors/semantics'
import Perk from '../../../Shop/Perks/Perk'
import {
  renderMoneyBackContent,
  renderPaymentContent,
  renderShippingContent,
  renderWarrantyContent
} from '../../../Shop/Perks'

// Sim rigs leave the factory on their own schedule rather than riding the
// regional courier transit time the other hardware quotes, so every rig surface
// (product pages + the GT-2 configurator) shows this single estimate.
export const RIG_TRANSIT_TIME_DAYS = '7-10'

// `transitTitle` overrides the business-days estimate (region fulfilment notices).
function ProductInfoTags({ transitTimeDays, transitTitle }) {
  return (
    <div className={styles.wrapper}>
      <Perk
        title={'30-Days money back guarantee'}
        textContent={renderMoneyBackContent()}
        icon={<AddIcon color={$textPrimary.light}/>}
        noPadding
        noBorder
      />
      { (transitTitle || transitTimeDays) &&
        <Perk
          title={transitTitle || `Estimated ${transitTimeDays} business days delivery`}
          textContent={renderShippingContent()}
          icon={<AddIcon color={$textPrimary.light}/>}
          noPadding
          noBorder
        />
      }
      <Perk
        title={'3-year warranty'}
        textContent={renderWarrantyContent()}
        icon={<AddIcon color={$textPrimary.light}/>}
        noPadding
        noBorder
      />
      <Perk
        title={'Secure payment'}
        textContent={renderPaymentContent()}
        icon={<AddIcon color={$textPrimary.light}/>}
        noPadding
        noBorder
      />
    </div>
  )
}

export default ProductInfoTags
